import api from "@/api.js";

export default {
  namespaced: true,
  modules: {

  },
  state: {
    list: [],
    listLoading: false,
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
  },
  actions: {
    async loadAll({ commit }) {
      commit("setListLoading", true);
      let list = await api.get("businessFindEntriesLikes");
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadAllByBusinessID({ commit }) {
      commit("setListLoading", true);
      let list = await api.get("businessFindEntriesLikes/ByBusinessID");
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`businessFindEntriesLikes`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      return returnData;
    }
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
  }
}
